export default function PageLoader() {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <div className="relative w-12 h-12">
          <div className="absolute inset-0 rounded-full border-4 border-ink-100"></div>
          <div className="absolute inset-0 rounded-full border-4 border-t-cta-500 animate-spin"></div>
        </div>
        <p className="text-sm text-ink-400">Loading...</p>
      </div>
    </div>
  );
}